import React from 'react'

function Lists() {
  return (
    <div className="  ">
      Lists
    </div>
  );
}

export default Lists